<template>
  <div>
    <div class="card shadow mb-4">
      <div class="card-header py-3">
        <span class="m-0 font-weight-bold text-success">Profile</span>
      </div>
      <div class="card-body">
        <div class="card shadow mb-4">
          <div class="card-header">
            <span class="m-0 font-weight-bold text-success">
              Shop Details
            </span>
            <span class="pull-right">
              <button
                class="btn btn-info"
                @click="ShopDetailsreadOnly = !ShopDetailsreadOnly"
              >
                <i class="fa fa-pencil"></i>
              </button>
              &nbsp;&nbsp;
              <button
                class="btn btn-success"
                v-if="!ShopDetailsreadOnly"
                @click="EditShopDetails()"
              >
                Save
              </button>
            </span>
          </div>
          <div v-if="addProductloading">
            <div class="col-md-12 text-center">
              <sweetalert-icon :icon="loadingType" />
            </div>
            <div class="col-md-12 text-center">
              <h3 class="text-center">{{ loadingMessage }}</h3>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="form-group row">
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>Shop Name</label>
                <input
                  type="text"
                  class="form-control form-control-user"
                  v-model="newShopDetails.name"
                  :readonly="ShopDetailsreadOnly"
                  required
                  placeholder="Shop Name"
                />
              </div>
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>Shop Email</label>
                <input
                  type="text"
                  class="form-control form-control-user"
                  v-model="newShopDetails.email"
                  :readonly="ShopDetailsreadOnly"
                  required
                  placeholder="Shop Email"
                />
              </div>
            </div>
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-success">
                  Address
                </h6>
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>First Line</label>
                    <input
                      type="text"
                      class="form-control form-control-user"
                      v-model="newShopDetails.address.firstLine"
                      :readonly="ShopDetailsreadOnly"
                      required
                      placeholder="Shop Name"
                    />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>City</label>
                    <input
                      type="text"
                      class="form-control form-control-user"
                      v-model="newShopDetails.address.city"
                      :readonly="ShopDetailsreadOnly"
                      required
                      placeholder="Shop City"
                    />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>State</label>
                    <input
                      type="text"
                      class="form-control form-control-user"
                      v-model="newShopDetails.address.state"
                      :readonly="ShopDetailsreadOnly"
                      required
                      placeholder="Shop State"
                    />
                  </div>
                  <div class="col-sm-6 mb-3 mb-sm-0">
                    <label>Pincode</label>
                    <input
                      type="text"
                      class="form-control form-control-user"
                      v-model="newShopDetails.address.pincode"
                      :readonly="ShopDetailsreadOnly"
                      required
                      placeholder="Shop City"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow mb-4">
          <div class="card-header">
            <span class="m-0 font-weight-bold text-success">
              Bank Details
            </span>
            <span class="pull-right">
              <button
                class="btn btn-info"
                @click="BankDetailssreadOnly = !BankDetailssreadOnly"
              >
                <i class="fa fa-pencil"></i>
              </button>
              &nbsp;&nbsp;
              <button
                class="btn btn-success"
                v-if="!BankDetailssreadOnly"
                @click="EditBankDetails()"
                :disabled="accouterror"
              >
                Save
              </button>
            </span>
          </div>
          <div v-if="addBankloading">
            <div class="col-md-12 text-center">
              <sweetalert-icon :icon="loadingType" />
            </div>
            <div class="col-md-12 text-center">
              <h3 class="text-center">{{ loadingMessage }}</h3>
            </div>
          </div>
          <div class="card-body" v-else>
            <div class="form-group row">
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>Bank Name</label>
                <input
                  type="text"
                  class="form-control form-control-user"
                  v-model="newBankDetails.bankDetails.name"
                  :readonly="BankDetailssreadOnly"
                  required
                  placeholder="Shop Name"
                />
              </div>
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>IFSC Code</label>
                <input
                  type="text"
                  class="form-control form-control-user"
                  v-model="newBankDetails.bankDetails.ifsc"
                  :readonly="BankDetailssreadOnly"
                  required
                  placeholder="Enter IFSC Code"
                />
              </div>
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>Account Number</label>
                <input
                  type="text"
                  class="form-control form-control-user"
                  v-model="newBankDetails.bankDetails.number"
                  :readonly="BankDetailssreadOnly"
                  required
                  placeholder="Account Number"
                />
              </div>
              <div class="col-sm-6 mb-3 mb-sm-0">
                <label>Re Enter Number</label>
                <input
                  type="password"
                  class="form-control form-control-user"
                  @input="CheckAccountValue()"
                  v-model="newAccountNumber"
                  :readonly="BankDetailssreadOnly"
                  required
                  placeholder="Re-Enter Account Number"
                />
                <span class="text-danger">{{ erroAccount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="card shadow">
          <div class="card-header">
            <span class="m-0 font-weight-bold text-success">
              Document
            </span>
            <button
              class="btn btn-primary pull-right"
              @click="add_document_model = !add_document_model"
            >
              <i class="fa fa-plus"></i>
            </button>
            <b-modal
              v-model="add_document_model"
              title="Add Document"
              hide-footer=""
            >
              <div v-if="addProductloading">
                <div class="col-md-12 text-center">
                  <sweetalert-icon :icon="loadingType" />
                </div>
                <div class="col-md-12 text-center">
                  <h3 class="text-center">{{ loadingMessage }}</h3>
                </div>
              </div>
              <b-form v-on:submit.prevent="SaveDocument" v-else>
                <b-form-group label="Select Document:">
                  <b-form-select
                    v-model="newDocument.name"
                    required
                    class="form-control"
                    :options="documentlist"
                  >
                  </b-form-select>
                </b-form-group>
                <b-form-group label="Document Number:">
                  <b-form-input
                    id="input-1"
                    v-model="newDocument.number"
                    type="text"
                    required
                    class="form-control"
                    placeholder="Enter Document Number"
                  ></b-form-input>
                </b-form-group>
                <button type="submit" class="btn btn-success btn-lg">
                  Save
                </button>
              </b-form>
            </b-modal>
          </div>
          <div class="card-body table-responsive">
            <table class="table">
              <thead>
                <th>#</th>
                <th>Document Name</th>
                <th>Number</th>
                <th>Status</th>
                <th>Action</th>
              </thead>
              <tbody>
                <tr
                  v-for="(document, docindex) in vendor.document"
                  :key="docindex"
                >
                  <td>{{ ++docindex }}</td>
                  <td>{{ document.name }}</td>
                  <td>{{ document.number }}</td>
                  <td>
                    <b-badge variant="success" v-if="document.verify">
                      verify
                    </b-badge>
                    <b-badge variant="danger" v-else>
                      not Verify
                    </b-badge>
                  </td>
                  <td>
                    <button class="btn btn-primary btn-sm">
                      <i class="fa fa-eye"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dbFs } from "@/modules/database";
export default {
  data() {
    return {
      vendor: [],
      add_document_model: false,
      accouterror: true,
      erroAccount: "",
      ShopDetailsreadOnly: true,
      BankDetailssreadOnly: true,
      loading: false,
      newAccountNumber: "",
      addProductloading: false,
      addBankloading: false,
      loadingType: "loading",
      loadingMessage: "Uploading",
      newDocument: { name: null, number: "", verify: false },
      newShopDetails: {},
      newBankDetails: {},
      documentlist: [
        {
          text: "Select Document",
          value: null
        },
        {
          text: "Aadhar Card",
          value: "Aadhar Card"
        },
        {
          text: "Pan Card",
          value: "Pan Card"
        },
        {
          text: "GST Certificate",
          value: "GST  Certificate"
        }
      ]
    };
  },
  mounted() {
    this.setupFirebaseReading();
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.$bind(
        "vendor",
        dbFs.collection("vendor").doc(this.$route.params.vendorId)
      )
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.newShopDetails = this.vendor.shopDetails;
          this.newBankDetails = this.vendor.payment;
          this.loading = false;
        });
    },
    SaveDocument() {
      this.addProductloading = true;
      this.loadingMessage = "Adding Document";
      let newdocument = this.vendor.document;
      newdocument.push({
        name: this.newDocument.name,
        number: this.newDocument.number,
        verify: false
      });
      dbFs;
      dbFs
        .collection("vendor")
        .doc(this.$route.params.vendorId)
        .update({
          document: newdocument
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingType = "success";
          this.loadingMessage = "Document Added Successfull";
          this.newDocument = {
            name: null,
            number: "",
            verify: false
          };
          setTimeout(() => {
            (this.add_document_model = false), (this.addProductloading = false);
          }, 3000);
        });
    },
    EditShopDetails() {
      this.addProductloading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Updating Shop Details";
      let id = this.$route.params.vendorId;
      dbFs
        .collection("vendor")
        .doc(id)
        .update({ shopDetails: this.newShopDetails })
        .then(() => {
          this.loadingType = "success";
          this.loadingMessage = "ShopDetails Update";
          setTimeout(() => {
            this.ShopDetailsreadOnly = true;
            this.addProductloading = false;
          }, 2000);
        });
    },
    EditBankDetails() {
      this.addBankloading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Updating Bank Details";
      let id = this.$route.params.vendorId;
      dbFs
        .collection("vendor")
        .doc(id)
        .update({ payment: this.newBankDetails })
        .then(() => {
          this.loadingType = "success";
          this.loadingMessage = "Bank Details Update";
          setTimeout(() => {
            this.BankDetailssreadOnly = true;
            this.addBankloading = false;
          }, 2000);
        });
    },
    CheckAccountValue() {
      if (this.newAccountNumber == this.newBankDetails.bankDetails.number) {
        console.log(this.newBankDetails.bankDetails.number);
        this.accouterror = false;
        this.erroAccount = "";
        return true;
      } else {
        this.erroAccount = "Account Number Not Match";
        return false;
      }
    }
  }
};
</script>

<style scoped>
/* @import url("https://blackrockdigital.github.io/startbootstrap-sb-admin-2/vendor/fontawesome-free/css/all.min.css"); */
</style>
